import Nullstack from 'nullstack';
export default function IconLanguage({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-language",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 5h7"
  }), "   ", Nullstack.element("path", {
    d: "M9 3v2c0 4.418 -2.239 8 -5 8"
  }), "   ", Nullstack.element("path", {
    d: "M5 9c-.003 2.144 2.952 3.908 6.7 4"
  }), "   ", Nullstack.element("path", {
    d: "M12 20l4 -9l4 9"
  }), "   ", Nullstack.element("path", {
    d: "M19.1 18h-6.2"
  }), " ");
}